import get from 'lodash/get';

import {
  addUserPhone,
  checkUpdatePasswordKeyAction,
  cleanAggregationsAction,
  clearProfilesAction,
  enqueueSnackbarAction,
  getActiveProfileAction,
  getAgenciesAction,
  clearAgenciesAction,
  setStartAggregationAction,
  getAggregationsAction,
  getArtistProfessionsAction,
  getCommonUserData,
  getCompaniesAction,
  clearCompaniesAction,
  getProfilesAction,
  loginUser,
  logoutAction,
  removeSnackbarAction,
  resetPasswordAction,
  setActiveProfileAction,
  setUserData,
  setUserProfiles,
  updatePasswordAction,
  updateUserData,
  getUserPermissionsAction,
  getProfilePermissionsAction,
  getArtistVoiceTypesAction,
  resetResetPasswordAction,
  deleteUserPhone,
  getCitiesAction,
  resetCitiesAction,
  getVenuesAction,
  resetVenuesAction,
  getVenuesSearchAction,
  resetVenuesSearchAction,
  getSettings,
  getStagesAction,
  useBufferValueAction,
  getWorkTypesAction,
  getWorkStylesAction,
  getPrivacyOptionsAction,
  getAOSProfessionsAction,
  getLanguagesAction,
  getDynamicCountriesAction,
  getUserInfoAction,
  getMediaAttrTypesAction,
  getVideoFormatAttrTypesAction,
  getActiveProfileSubscriptionsAction,
  getProfileSubscriptionsAction,
  getSubscriptionsAction,
  setSubscriptionChurnedStatus,
  setProfileIdsWithAccess,
  getSearchProductionsAction,
  addProfileIdsWithAccess,
  getProfileAccessRequestsAction,
} from './actions';
import { changePasswordAction } from '../UserContainers/AccountSettingsContainer/actions';
import {
  defaultEntityParams,
  defaultListParams,
  entityReducer,
  listReducer,
  namedListParams,
} from '../../utils/crudUtils';

import { CLEAN_SEARCH_PRODUCTIONS_LIST } from './constants';

export const initialState = {
  userData: {},
  profilePermissions: {
    permissions: [],
    isLoading: false,
    loadedOnce: false,
    error: null,
  },
  savedPermissions: {
    permissions: [],
    agencies: [],
    companies: [],
    profileId: null,
  },
  userPermissions: {
    permissions: [],
    isLoading: false,
    loadedOnce: false,
    error: null,
  },
  profiles: [],
  isProfilesLoading: false,
  activeProfileData: {},
  isSwitchingProfile: false,

  activeProfileSubscriptions: [],
  profileSubscriptions: [],
  subscriptionChurnedStatus: false,
  subscriptions: defaultListParams,

  resetPasswordInfo: null,
  isResetPasswordKeyActive: false,
  isPasswordUpdated: false,

  startAggregations: false,
  aggregations: {
    error: null,
  },
  aggregationTypeLoading: '',

  artistProfessions: [],
  agencies: [],
  agenciesLoading: false,
  companies: [],
  companiesLoading: false,

  profilesList: [],
  profilesListLoading: false,
  profileIdsWithAccess: [],

  loading: false,
  error: null,
  notifications: [],
  loginError: null,
  loginLoading: false,
  loginTries: 0,

  voiceTypes: defaultListParams,
  cities: defaultListParams,
  venues: defaultListParams,
  venueSearch: [],
  venuesSearchLoading: false,
  stages: defaultListParams,

  settings: namedListParams('settings'),
  bufferValue: defaultEntityParams,
  workTypes: defaultListParams,
  workStyles: defaultListParams,
  privacyOptions: defaultListParams,
  aosProfessions: defaultListParams,
  notificationBanner: null,
  languages: defaultListParams,
  dynamicCountries: namedListParams('dynamicCountries'),
  userInfo: {
    data: {},
    error: null,
    isLoading: false,
  },
  isUserInfoLoading: false,
  attributeTypes: namedListParams('attributeTypes'),
  videoFormats: namedListParams('videoFormats'),

  searchProductions: defaultListParams,

  profileAccessRequests: [],
};

const appReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case loginUser.TRIGGER:
      return { ...state, loginLoading: true, loginError: null };
    case loginUser.SUCCESS:
      return { ...state, loginLoading: false, userData: payload.user, loginTries: 0 };
    case loginUser.FAILURE:
      return {
        ...state,
        loginLoading: false,
        loginError: payload,
        loginTries: payload === 'Password is incorrect' ? state.loginTries + 1 : state.loginTries,
      };

    case logoutAction.TRIGGER:
      return { ...state, userData: {} };

    case getCommonUserData.FAILURE:
      return { ...state, loading: false, error: payload };

    case setUserData.TRIGGER:
      return { ...state, userData: payload.user };
    case setUserData.SUCCESS:
      return { ...state, userData: payload };
    case setUserData.FAILURE:
      return { ...state, error: payload };

    case updateUserData.TRIGGER:
    case addUserPhone.TRIGGER:
    case deleteUserPhone.TRIGGER:
    case changePasswordAction.TRIGGER:
      return { ...state, loading: true };
    case updateUserData.SUCCESS:
    case addUserPhone.SUCCESS:
    case deleteUserPhone.SUCCESS:
    case changePasswordAction.SUCCESS:
      return { ...state, loading: false, userData: payload };
    case updateUserData.FAILURE:
    case addUserPhone.FAILURE:
    case deleteUserPhone.FAILURE:
    case changePasswordAction.ERROR:
      return { ...state, loading: false, error: payload };

    case setUserProfiles.TRIGGER:
      return { ...state, isProfilesLoading: true };
    case setUserProfiles.SUCCESS:
      return { ...state, profiles: payload, isProfilesLoading: false };
    case setUserProfiles.FAILURE:
      return { ...state, error: payload, isProfilesLoading: false };
    case setProfileIdsWithAccess.TRIGGER:
    case setProfileIdsWithAccess.SUCCESS:
    case setProfileIdsWithAccess.FAILURE:
      return { ...state, profileIdsWithAccess: payload };

    case addProfileIdsWithAccess.TRIGGER:
      return { ...state, profileIdsWithAccess: [...state.profileIdsWithAccess, ...(payload || [])] };

    case getActiveProfileAction.SUCCESS:
      return { ...state, activeProfileData: payload };

    case getActiveProfileAction.FAILURE:
      return { ...state, error: payload };

    case getActiveProfileSubscriptionsAction.SUCCESS:
      return { ...state, activeProfileSubscriptions: payload };

    case getProfileSubscriptionsAction.SUCCESS:
      return { ...state, profileSubscriptions: payload };

    case getSubscriptionsAction.TRIGGER:
    case getSubscriptionsAction.SUCCESS:
    case getSubscriptionsAction.FAILURE: {
      return listReducer(state, type, payload, 'subscriptions');
    }
    case setSubscriptionChurnedStatus.TRIGGER:
      return { ...state, subscriptionChurnedStatus: payload };

    case setActiveProfileAction.TRIGGER:
      return { ...state, isSwitchingProfile: !payload.fromReg };
    case setActiveProfileAction.SUCCESS:
      return { ...state, activeProfileData: payload, isSwitchingProfile: false };
    case setActiveProfileAction.FAILURE:
      return { ...state, error: payload, isSwitchingProfile: false };

    case getArtistProfessionsAction.SUCCESS:
      return { ...state, artistProfessions: payload };
    case getArtistProfessionsAction.FAILURE:
      return { ...state, error: payload };

    case setStartAggregationAction.TRIGGER:
      return { ...state, startAggregations: true };

    case getAggregationsAction.TRIGGER:
      return { ...state, aggregationTypeLoading: get(payload, 'fieldName') || get(payload, 'query.aggregation_type') };
    case getAggregationsAction.SUCCESS:
      return {
        ...state,
        aggregations: { ...state.aggregations, [payload.criteria.aggregation_type]: payload.data, error: null },
        aggregationTypeLoading: null,
        startAggregations: false,
      };
    case getAggregationsAction.FAILURE:
      return { ...state, aggregations: { error: payload }, aggregationTypeLoading: '', startAggregations: false };
    case cleanAggregationsAction.TRIGGER:
      return { ...state, aggregations: { ...state.aggregations, [payload]: [], error: null } };

    case getAgenciesAction.TRIGGER:
      return { ...state, agenciesLoading: true };
    case getAgenciesAction.SUCCESS:
      return { ...state, agencies: payload, agenciesLoading: false };
    case getAgenciesAction.FAILURE:
      return { ...state, agencies: [], agenciesLoading: false, error: payload };
    case clearAgenciesAction.TRIGGER:
      return { ...state, agencies: [] };

    case getCompaniesAction.TRIGGER:
      return { ...state, companiesLoading: true };
    case getCompaniesAction.SUCCESS:
      return { ...state, companies: payload, companiesLoading: false };
    case getCompaniesAction.FAILURE:
      return { ...state, companies: [], error: payload, companiesLoading: false };
    case clearCompaniesAction.TRIGGER:
      return { ...state, companies: [], companiesLoading: false };

    case getProfilesAction.TRIGGER:
      return { ...state, profilesListLoading: true };
    case getProfilesAction.SUCCESS:
      return { ...state, profilesList: payload, profilesListLoading: false };
    case getProfilesAction.FAILURE:
      return { ...state, profilesList: [], error: payload, profilesListLoading: false };
    case clearProfilesAction.TRIGGER:
      return { ...state, profilesList: [], profilesListLoading: false };

    case resetPasswordAction.SUCCESS:
      return { ...state, resetPasswordInfo: 'success' };
    case resetPasswordAction.FAILURE:
      return { ...state, resetPasswordInfo: payload };

    case resetResetPasswordAction.TRIGGER:
      return { ...state, resetPasswordInfo: '' };

    case checkUpdatePasswordKeyAction.SUCCESS:
      return { ...state, isResetPasswordKeyActive: true };
    case checkUpdatePasswordKeyAction.FAILURE:
      return { ...state, resetPasswordInfo: payload };

    case updatePasswordAction.SUCCESS:
      return { ...state, isPasswordUpdated: true };

    case enqueueSnackbarAction.TRIGGER:
      return {
        ...state,
        notifications: [
          ...state.notifications,
          { ...payload, key: get(payload, 'options.key', new Date().getTime() + Math.random()) },
        ],
      };

    case removeSnackbarAction.TRIGGER:
      return {
        ...state,
        notifications: state.notifications.filter(notification => get(notification, 'key') !== payload),
      };

    case getUserPermissionsAction.TRIGGER:
      return {
        ...state,
        userPermissions: {
          error: null,
          isLoading: true,
          permissions: [],
          loadedOnce: state.userPermissions.loadedOnce,
        },
      };
    case getUserPermissionsAction.SUCCESS:
      return { ...state, userPermissions: { isLoading: false, permissions: payload, loadedOnce: true } };
    case getUserPermissionsAction.FAILURE:
      return {
        ...state,
        userPermissions: {
          error: payload,
          isLoading: false,
          permissions: [],
          loadedOnce: state.userPermissions.loadedOnce,
        },
      };

    case getProfilePermissionsAction.TRIGGER:
      return {
        ...state,
        profilePermissions: {
          error: null,
          isLoading: true,
          permissions: [],
          loadedOnce: state.profilePermissions.loadedOnce,
        },
      };
    case getProfilePermissionsAction.SUCCESS:
      return { ...state, profilePermissions: { isLoading: false, permissions: payload, loadedOnce: true } };
    case getProfilePermissionsAction.FAILURE:
      return {
        ...state,
        profilePermissions: {
          error: payload,
          isLoading: false,
          loadedOnce: state.profilePermissions.loadedOnce,
          permissions: [],
        },
      };
    case getArtistVoiceTypesAction.TRIGGER:
    case getArtistVoiceTypesAction.SUCCESS:
    case getArtistVoiceTypesAction.FAILURE:
      return listReducer(state, type, payload, 'voiceTypes');

    case getSettings.TRIGGER:
    case getSettings.SUCCESS:
    case getSettings.FAILURE:
      return listReducer(state, type, payload, initialState.settings.listName);

    case getCitiesAction.TRIGGER:
    case getCitiesAction.SUCCESS:
    case getCitiesAction.FAILURE:
      return { ...listReducer(state, type, payload, 'cities'), aggregationTypeLoading: get(payload, 'fieldName', '') };

    case resetCitiesAction.TRIGGER:
      return { ...state, cities: { ...state.cities, data: [] } };

    case getVenuesSearchAction.TRIGGER:
      return { ...state, venuesSearchLoading: true };
    case getVenuesSearchAction.SUCCESS:
      return { ...state, venueSearch: payload, venuesSearchLoading: false };
    case getVenuesSearchAction.FAILURE:
      return { ...state, venueSearch: [], error: payload, venuesSearchLoading: false };
    case resetVenuesSearchAction.TRIGGER:
      return { ...state, venueSearch: [], venuesSearchLoading: false };

    case getVenuesAction.TRIGGER:
    case getVenuesAction.SUCCESS:
    case getVenuesAction.FAILURE:
      return listReducer(state, type, payload, 'venues');
    case resetVenuesAction.TRIGGER:
      return { ...state, venues: { ...state.venues, data: [] } };

    case getStagesAction.TRIGGER:
    case getStagesAction.SUCCESS:
    case getStagesAction.FAILURE:
      return listReducer(state, type, payload, 'stages');

    case useBufferValueAction.TRIGGER:
    case useBufferValueAction.SUCCESS:
    case useBufferValueAction.FAILURE:
      return entityReducer(state, type, payload, 'bufferValue');

    case getWorkTypesAction.TRIGGER:
    case getWorkTypesAction.SUCCESS:
    case getWorkTypesAction.FAILURE:
      return listReducer(state, type, payload, 'workTypes');

    case getWorkStylesAction.TRIGGER:
    case getWorkStylesAction.SUCCESS:
    case getWorkStylesAction.FAILURE:
      return listReducer(state, type, payload, 'workStyles');

    case getPrivacyOptionsAction.TRIGGER:
    case getPrivacyOptionsAction.SUCCESS:
    case getPrivacyOptionsAction.FAILURE:
      return listReducer(state, type, payload, 'privacyOptions');

    case getAOSProfessionsAction.TRIGGER:
    case getAOSProfessionsAction.SUCCESS:
    case getAOSProfessionsAction.FAILURE:
      return listReducer(state, type, payload, 'aosProfessions');

    case getLanguagesAction.TRIGGER:
    case getLanguagesAction.SUCCESS:
    case getLanguagesAction.FAILURE:
      return listReducer(state, type, payload, 'languages');

    case getDynamicCountriesAction.TRIGGER:
    case getDynamicCountriesAction.SUCCESS:
    case getDynamicCountriesAction.FAILURE:
      return {
        ...listReducer(state, type, payload, state.dynamicCountries.listName),
        aggregationTypeLoading: payload?.fieldName || '',
      };

    case getUserInfoAction.TRIGGER:
      return {
        ...state,
        userInfo: {
          data: {},
          error: null,
          isLoading: true,
        },
      };
    case getUserInfoAction.SUCCESS:
      return { ...state, userInfo: { data: payload, isLoading: false } };
    case getUserInfoAction.FAILURE:
      return { ...state, userInfo: { error: payload, data: {}, isLoading: false } };
    case getMediaAttrTypesAction.FAILURE:
    case getMediaAttrTypesAction.TRIGGER:
    case getMediaAttrTypesAction.SUCCESS:
      return listReducer(state, type, payload, initialState.attributeTypes.listName);

    case getVideoFormatAttrTypesAction.FAILURE:
    case getVideoFormatAttrTypesAction.TRIGGER:
    case getVideoFormatAttrTypesAction.SUCCESS:
      return listReducer(state, type, payload, state.videoFormats.listName);

    case getSearchProductionsAction.FAILURE:
    case getSearchProductionsAction.TRIGGER:
    case getSearchProductionsAction.SUCCESS:
      return listReducer(state, type, payload, 'searchProductions');

    case CLEAN_SEARCH_PRODUCTIONS_LIST:
      return { ...state, searchProductions: defaultListParams };

    case getProfileAccessRequestsAction.TRIGGER:
    case getProfileAccessRequestsAction.SUCCESS:
    case getProfileAccessRequestsAction.FAILURE:
      return { ...state, profileAccessRequests: payload };

    default:
      return state;
  }
};

export default appReducer;
